// extracted by mini-css-extract-plugin
export default {"instantSearchHeader":"InstantSearchHeader_instantSearchHeader__uov5r","searchFormControl":"InstantSearchHeader_searchFormControl__ipgAu","escBtn":"InstantSearchHeader_escBtn__QiraP"};